export default __webpack_public_path__ + "static/media/bank-kalsel.1d25dd33.png";